import SubmittingComments from "./components/submitting-coments/SubmittingComents";
import { withNavigationWatcher } from "./contexts/navigation";
import { Home } from "./pages";
import AccessDenied from "./pages/access-denied/AccessDenied";
import AdminPanel from "./pages/admin-panel/AdminPanel";
import Announcements from "./pages/announcements/Announcements";
import { Availability } from "./pages/availability/Availability";
import { AwardsSummary } from "./pages/award-summary/AwardsSummary";
import { Awards } from "./pages/awards/Awards";
import { CalendarWork } from "./pages/calendar/Calendar";
import { ChangePasswordByAdmin } from "./pages/change-password-by-admin/ChangePasswordByAdmin";
import { ChangePassword } from "./pages/change-password/ChangePassword";
import { ChangeEmailByAdmin } from "./pages/change-user-email/ChangeUserEmail";
import { DisableAccountLocks } from "./pages/disable-account-locks/DisableAccountLocks";
import { Documents } from "./pages/documents/Documents";
import EmployeesList from "./pages/employees-list/EmployeesList";
import { EvaluationSummary } from "./pages/evaluation-summary/EvaluationSummary";
import { Holiday2 } from "./pages/holiday2/Holiday2";
import { HourlySummary } from "./pages/hourly-summary/HourlySummary";
import PresencePage from "./pages/presence/PresencePage";
import Projects from "./pages/projects/Projects";
import { Rate } from "./pages/rate/Rate";
import { ReadingNotes } from "./pages/reading-notes/ReadingNotes";
import { Schedule } from "./pages/schedule/Schedule";
import { Sheets } from "./pages/sheets/Sheets";
import { TransferOfEmployees2 } from "./pages/transfer-of-employees2/TransferOfEmployees2";
import { TwoFactorAuthentication } from "./pages/two-factor-authentication/TwoFactorAuthentication";
import WorkPlan from "./pages/work-plan/WorkPlan";

const routes = [
  {
    path: "/",
    element: Home,
  },
  {
    path: "/2fa",
    element: TwoFactorAuthentication,
  },
  {
    path: "/change-password",
    element: ChangePassword,
  },
  {
    path: "/employees",
    element: EmployeesList,
  },
  {
    path: "/admin-panel",
    element: AdminPanel,
  },
  {
    path: "/change-password-by-admin",
    element: ChangePasswordByAdmin,
  },
  {
    path: "/change-email-by-admin",
    element: ChangeEmailByAdmin,
  },
  {
    path: "/disable-account-locks",
    element: DisableAccountLocks,
  },
  {
    path: "/work-plan",
    element: WorkPlan,
  },
  {
    path: "/availability",
    element: Availability,
  },
  {
    path: "/calendar",
    element: CalendarWork,
  },
  {
    path: "/holiday",
    element: Holiday2,
  },
  {
    path: "/presence",
    element: PresencePage,
  },
  {
    path: "/transfer-of-employees",
    element: TransferOfEmployees2,
  },
  {
    path: "/projects",
    element: Projects,
  },
  {
    path: "/rate",
    element: Rate,
  },
  {
    path: "/sheets",
    element: Sheets,
  },
  {
    path: "/hourly-summary",
    element: HourlySummary,
  },
  {
    path: "/evalutation-summary",
    element: EvaluationSummary,
  },
  {
    path: "/awards",
    element: Awards,
  },
  {
    path: "/awards/summary",
    element: AwardsSummary,
  },
  {
    path: "/submitting-comments",
    element: SubmittingComments,
  },
  {
    path: "/schedule",
    element: Schedule,
  },
  {
    path: "/announcements",
    element: Announcements,
  },
  {
    path: "/reading-notes",
    element: ReadingNotes,
  },
  {
    path: "/documents",
    element: Documents,
  },
  {
    path: "/access-denied",
    element: AccessDenied,
  },
];

export const appRoutes = routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
